/**
 * 悟空图片布局配置 - 按阶段(phase)分别配置
 * 支持默认状态与挨饿状态的不同 size、top、left
 *
 * phase: 1-12 对应幼年悟空到齐天大圣
 * 每项 { default: { top, width, left? }, hungry: { top, width, left? } }
 * top/width 使用 rem 或 px，left 可选
 */
export const PET_LAYOUT_CONFIG = {
  1: {
    default: { top: '', width: '30rem', left: '' },
    hungry: { top: '-27rem', width: '25rem', left: '' },
  },
  2: {
    default: { top: '', width: '30rem', left: '' },
    hungry: { top: '', width: '30rem', left: '' },
  },
  3: {
    default: { top: '', width: '30rem', left: '' },
    hungry: { top: '-30rem', width: '25rem', left: '' },
  },
  4: {
    default: { top: '-33rem', width: '30rem', left: '2rem' },
    hungry: { top: '-29rem', width: '28rem', left: '2rem' },
  },
  5: {
    default: { top: '-35rem', width: '34rem', left: '' },
    hungry: { top: '-30rem', width: '28rem', left: '' },
  },
  6: {
    default: { top: '', width: '30rem', left: '' },
    hungry: { top: '', width: '28rem', left: '' },
  },
  7: {
    default: { top: '-38rem', width: '30rem', left: '' },
    hungry: { top: '-30rem', width: '28rem', left: '' },
  },
  8: {
    default: { top: '-41rem', width: '30rem', left: '' },
    hungry: { top: '-25rem', width: '23rem', left: '' },
  },
  9: {
    default: { top: '-38rem', width: '30rem', left: '' },
    hungry: { top: '-36rem', width: '35rem', left: '' },
  },
  10: {
    default: { top: '-38.3rem', width: '30rem', left: '' },
    hungry: { top: '-30rem', width: '30rem', left: '' },
  },
  11: {
    default: { top: '-36rem', width: '30rem', left: '' },
    hungry: { top: '-30rem', width: '25rem', left: '' },
  },
  12: {
    default: { top: '-37rem', width: '30rem', left: '' },
    hungry: { top: '-48rem', width: '30rem', left: '' },
  },
  13: {
    default: { top: '-43rem', width: '32rem', left: '', aspectRatio: '320 / 569' },
    hungry: { top: '-43rem', width: '32rem', left: '', aspectRatio: '320 / 569' },
  },
  14: {
    default: { top: '-34rem', width: '30rem', left: '' },
    hungry: { top: '-34rem', width: '30rem', left: '' },
  },
  15: {
    default: { top: '-34rem', width: '30rem', left: '' },
    hungry: { top: '-34rem', width: '30rem', left: '' },
  },
  16: {
    default: { top: '-34rem', width: '30rem', left: '' },
    hungry: { top: '-34rem', width: '30rem', left: '' },
  },
};

const FALLBACK_LAYOUT = { top: '', width: '30rem', left: '' };

/**
 * 获取指定阶段、状态的布局样式
 * @param {number} phase - 1-12
 * @param {boolean} isHungry - 是否挨饿
 * @returns {{ top: string, width: string, left: string }}
 */
export const getPetLayout = (phase, isHungry) => {
  const cfg = PET_LAYOUT_CONFIG[phase];
  if (!cfg) return FALLBACK_LAYOUT;
  const layout = isHungry ? cfg.hungry : cfg.default;
  return {
    top: layout?.top ?? FALLBACK_LAYOUT.top,
    width: layout?.width ?? FALLBACK_LAYOUT.width,
    left: layout?.left ?? FALLBACK_LAYOUT.left,
    aspectRatio: layout?.aspectRatio ?? '',
  };
};
